import React from 'react';

const JS_Modules = () => {
  return (
    <div >
      <h1>JS_Modules</h1>
      <p>Placeholder component for: "JS Modules"</p>
    </div>
  );
};

export default JS_Modules;
